<template>
  <div class="footer">
    <div class="foot-content">
      <div class="list about">
        <span class="item">
          <a class="txt" href="/" target="_blank">关于我们</a>
        </span>
        <span class="gap">|</span>
        <span class="item">
          <a class="txt" href="/" target="_blank">用户协议</a>
        </span>
        <span class="gap">|</span>
        <span class="item">
          <a class="txt" href="/" target="_blank">隐私政策</a>
        </span>
        <span class="gap">|</span>
        <span class="item">
          <a class="txt" href="/" target="_blank">常见问题</a>
        </span>
        <span class="gap">|</span>
        <span class="item">
          <a class="txt" href="/" target="_blank">意见反馈</a>
        </span>
      </div>
      <div class="list copyright">
        <span class="item">
          <!-- <span class="tit">Copyright @ </span> -->
          <span class="txt">{{ infoData.copyright }}</span>
        </span>
        <span class="item">
          <span class="tit">技术支持:</span>
          <span class="txt">{{ infoData.support }}</span>
        </span>
        <span class="item">
          <!-- <span class="foot_icon"></span> -->
          <a class="txt" :href="infoData.icp_filing_url">{{ infoData.icp_filing_num }}</a>
        </span>
        <span class="item">
          <a class="txt" :href="infoData.net_filing_url">{{ infoData.net_filing }}</a>
        </span>
        <span class="item">
          <span class="tit">地址:</span>
          <span class="txt">{{ infoData.address }}</span>
        </span>
        <span class="item">
          <span class="tit">电话:</span>
          <span class="txt">{{ infoData.phone }}</span>
        </span>
        <span class="item">
          <span class="tit">邮编:</span>
          <span class="txt">{{ infoData.postal_code }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      infoData: {
        portal_end_logo: "",
        address: "",
        postal_code: "",
        phone: "",
        copyright: "",
        support: "",
        icp_filing_num: "",
        icp_filing_url: "",
        net_filing: "",
        net_filing_url: "",
      }, // 底部信息
    }
  },
  watch: {
    websiteInfo: {
      handler(newVal, oldVal) {
        this.setFooterInfo(newVal)
      },
      immediate: true,
      deep: true,
    },
    websiteFooter: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.initData(newVal)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState(['websiteInfo', 'websiteFooter']),
  },
  created() {
    this.initData() // 初始化数据
  },
  mounted() { },
  methods: {
    // 初始化数据
    initData(data) { },
    setFooterInfo(data) {
      this.infoData = data
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  padding: 20px 0;
  overflow: hidden;

  .foot-content {
    max-width: 1000px;
    overflow: hidden;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;

    .list {
      text-align: center;

      .item {
        display: inline-block;
        color: #fff;
        line-height: 40px;
        margin: 0 5px;

        .tit {
          font-size: 12px;
          font-weight: 400;
        }

        .txt {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    // 关于我们
    .about {
      .item {
        .txt {
          color: #e4e4e4;
          font-size: 15px;
          font-weight: 500;
          text-decoration: none;
        }
      }

      .gap {
        color: #fff;
        margin: 0 10px;
      }
    }

    .copyright {
      .item {

        .tit,
        .txt {
          color: #e4e4e4;
          font-size: 15px;
          font-weight: 500;
        }
      }

      .foot_icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('~@/assets/home/foot_icon.png') 0 0 no-repeat;
        background-size: 100% 100%;
        margin: 0px 8px;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .footer {
    // padding: 15px 10px;

    .foot-content {
      width: auto;
      max-width: 600px;
      margin: 0 auto;

      .list {
        .item {
          display: block;
          min-width: 60px;
          line-height: 1.8;
          margin: 2px 0;

          .tit,
          .txt {
            font-size: 12px !important;
          }
        }
      }

      .about {
        .gap {
          margin: 0 5px;
        }

        .item {
          display: inline-block;
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .footer {
    .foot-content {
      width: auto;
      min-width: 640px;
      max-width: 1160px;
      margin: 20px auto;

      .list {
        .item {
          min-width: 60px;
          line-height: 2;

          .tit,
          .txt {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .footer {
    .foot-content {
      width: auto;
      min-width: 1200px;
      max-width: 1800px;
      margin: 20px auto;
    }
  }
}
</style>